// The original AROS FLOW "rooms" home. Kept live as a fallback while the new
// product shell rolls out — every existing tool is still reachable from here.

import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app-shell";
import { Penthouse } from "@/components/penthouse";
import { ErrorBoundary } from "@/components/error-boundary";
import { BugReportWidget } from "@/components/bug-report";

export const Route = createFileRoute("/penthouse")({
  head: () => ({
    meta: [
      { title: "Classic Tools — AROS FLOW" },
      {
        name: "description",
        content:
          "The classic AROS FLOW workspace: Quick Deal Desk, ARV estimator, repair estimator and the training room, all in one place.",
      },
      { property: "og:title", content: "Classic Tools — AROS FLOW" },
      {
        property: "og:description",
        content:
          "Quick Deal Desk, ARV estimator, repair estimator and practice mode in the original AROS FLOW workspace.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <AppShell>
      <ErrorBoundary label="Penthouse crashed">
        <Penthouse />
      </ErrorBoundary>
      <BugReportWidget />
    </AppShell>
  );
}
